<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>核销商品列表</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入搜索：">
                  <el-input
                    v-model="form.woid"
                    placeholder="代采单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.new_goods_no"
                    placeholder="核销后商品货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-if="resData"
                    v-model="form.new_pgid"
                    placeholder="核销后代采组"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.optionPurchaseGroup"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.new_dbid"
                    placeholder="核销后打标id"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-input
                    v-model="form.old_goods_no"
                    placeholder="核销前商品货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-input
                    v-model="form.old_supply_name"
                    placeholder="核销前商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.city"
                    multiple
                    placeholder="选择城市"
                  >
                    <el-option
                      v-for="item in citys"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-if="resData"
                    v-model="form.old_pgid"
                    placeholder="核销前代采组"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.optionPurchaseGroup"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select v-model="form.origin" placeholder="选择地区">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in storehouseIds"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="核销时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
          >
            <el-table-column
              prop="dbid"
              label="核销后打标id"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="woid"
              label="代采单id"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="核销后货号"
              width="100"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="核销后商品名称"
              width="120"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="market_price"
              label="核销后商品金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="co_val"
              label="核销后颜色"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="si_val"
              label="核销后尺码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="ngoods_img"
              label="核销后商品图片"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.ngoods_img"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="核销后代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="核销后商家"
              width="120"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_city"
              label="城市"
              width="120"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="odbid"
              label="核销前打标id"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ogoods_no"
              label="核销前货号"
              width="100"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ogoods_name"
              label="核销前商品名称"
              width="120"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="omarket_price"
              label="核销前商品金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="oco_val"
              label="核销前颜色"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="osi_val"
              label="核销前尺码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ogoods_img"
              label="核销前商品图片"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.ogoods_img"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="opgname"
              label="核销前代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="osupply_name"
              label="核销前商家"
              width="120"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="hexiao_related_type"
              label="核销类型"
              width="120"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="remark"
              label="核销备注"
              width="120"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="admin_name"
              label="核销人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="核销时间"
              width="120"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="origin"
              label="仓库"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :pagesize="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {
        origin: 1,
        create_time: this.defaultDate(),
        city: "",
      },
      loading: false,
      url: "/erp/StockInRecord/hexiaoList",
      origin: [
        { key: 1, label: "广州" },
        { key: 2, label: "杭州" },
      ],
      storehouseIds: [],
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      citys: CITY,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 7);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.curPage = 1;
        }
      });
    },
    fetchData(showLoading) {
      this.$http
        .post("/erp/StockStorehouse/listStockStorehouseConfig")
        .then((res) => {
          if (res.data.code == 200) {
            this.storehouseIds = res.data.data;
          }
        });
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.filter {
  border: 1px solid #ddd;
}
</style>



// WEBPACK FOOTER //
// src/pages/hexiaoList.vue